import React, { useState, useEffect, useRef, useCallback, useContext, memo } from 'react';
import add_comment_img from "../../assets/images/icons/add-comment-img.png";
import { FaTimes } from 'react-icons/fa';
import { AddCommentApi } from '../../constants/API';
import { authorize } from '../../shared/authorize';
import "../feeds/comments/commentsection.css";
import axios from 'axios';
import { ShimmerThumbnail } from "react-shimmer-effects";
import "../course-details/course-content-details/listShimmer.css";
import { Language } from '../../App';
import './commentsection.css'
const AddComment = ({
  setParentId,
  postId,
  replyId,
  comment,
  setComment,
  selectedImage,
  setSelectedImage,
  commentLoading,
  replyingTo,
  setReplyingTo,
  handleGetComments,
  parentId,
  handleGetReplies
}) => {
  const [image, setImage] = useState(null);
  const [paddingLeft, setPaddingLeft] = useState(0);
  const [loading, setLoading] = useState(false);
  const replyTextRef = useRef(null);
  const textareaRef = useRef(null);
  const { lang } = useContext(Language);

  useEffect(() => {
    if (replyingTo) {
      const width = replyTextRef.current ? replyTextRef.current.offsetWidth : 0;
      setPaddingLeft(width + 10);
    } else {
      setPaddingLeft(10);
    }
  }, [replyingTo]);

  const handleImageClick = () => {
    document.getElementById('file-input').click();
  };

  useEffect(() => {
    if (replyingTo && textareaRef.current) {
      textareaRef.current.focus();
    }
  }, [replyingTo]);

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setImage(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setSelectedImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCommentChange = (event) => {
    let newValue = event.target.value;

    if (replyingTo) {
      const prefix = `${lang?.reply_to} ${replyingTo} `;
      if (newValue.startsWith(prefix)) {
        newValue = newValue.slice(prefix.length);
      }
    }

    setComment(newValue);

    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      const lineHeight = 20;
      const maxLines = 4;
      const newHeight = Math.min(textareaRef.current.scrollHeight, lineHeight * maxLines);
      textareaRef.current.style.height = `${newHeight}px`;
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    setSelectedImage(null);
  };

  const handleKeyDown = (event) => {
    if (event.key === "Backspace" && comment === "" && replyingTo) {
      event.preventDefault();
      setReplyingTo("");
      setParentId("");
    }
  };

  const handleSubmit = () => {
    if (!comment.trim() && !image) return;
    handleAddComment();
  };

  const handleAddComment = useCallback(async () => {
    if (loading) return;

    setLoading(true);

    try {
      const formData = new FormData();
      formData.append("comment", comment);
      formData.append("post_id", postId);

      if (image) {
        formData.append("image", image);
      }

      if (parentId) {
        formData.append("parent", parentId);
      }
      if (replyId) {
        formData.append("mentions", replyId);
      }

      const response = await axios.post(
        `${AddCommentApi}`,
        formData,
        {
          headers: {
            ...authorize().headers,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status) {
        setComment("");
        handleGetComments();
        parentId && handleGetReplies(parentId);
        setImage(null);
        setReplyingTo('');
        setSelectedImage(null);
        setParentId('');
      }
    } catch (error) {
      console.error("Error uploading comment:", error);
    } finally {
      setLoading(false);
    }
  }, [comment, postId, image, parentId, replyId, loading, handleGetComments, handleGetReplies, setComment, setReplyingTo, setSelectedImage, setParentId]);

  return (
    <>
      {commentLoading ? (
        <div className="d-flex align-items-center justify-content-between p-2 custom_list_shimmer">
          <div className="d-flex align-items-center gap-3 custom_list_shimmer">
            <ShimmerThumbnail height={30} width={40} rounded />
            <ShimmerThumbnail height={30} width={160} rounded />
          </div>
          <ShimmerThumbnail height={30} width={70} rounded />
        </div>
      ) : (
        <div className="add-comment-container">
          <div className="add-comment-image-wrapper">
            {selectedImage ? (
              <div className="add-comment-preview-container">
                <img
                  src={selectedImage}
                  alt="preview"
                  className="add-comment-preview-img"
                />
                <FaTimes
                  onClick={handleRemoveImage}
                  className="add-comment-remove-icon"
                />
              </div>
            ) : (
              <>
                {!replyingTo && (
                  <img
                    className="add-comment-upload-icon"
                    onClick={handleImageClick}
                    src={add_comment_img}
                    alt="add comment"
                  />
                )}
              </>
            )}
          </div>

          <input
            type="file"
            id="file-input"
            className="add-comment-file-input"
            onChange={handleImageChange}
            accept="image/*"
          />

          <div className="add-comment-input-wrapper">
            {replyingTo && (
              <span
                ref={replyTextRef}
                className="add-comment-replying-to"
              >
                {lang?.reply_to} {replyingTo}
              </span>
            )}

            <textarea
              value={replyingTo ? `${lang?.reply_to} ${replyingTo} ${comment}` : comment}
              onChange={handleCommentChange}
              onKeyDown={handleKeyDown}
              placeholder={lang?.add_comment}
              className="add-comment-textarea"
              ref={textareaRef}
              rows={1}
              style={{ paddingLeft: `${paddingLeft}px` }} // Only dynamic value kept inline
            />
          </div>

          <button
            className="add-comment-submit-btn"
            disabled={(!comment.trim() && !image) || loading}
            onClick={handleSubmit}
          >
            {loading ? <span className="post_loader"></span> : lang?.publish}
          </button>
        </div>
      )}
    </>
  );
};

export default memo(AddComment);